import { Component, OnInit, OnDestroy, input, inject, output } from "@angular/core";
import { ClozeTestStyleModel } from "../model/cloze-test-style-model";
import { TestResultDto } from "../dto/test-result-dto";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ExerciseIndicatorComponent } from "../exercise-indicator/exercise-indicator.component";
import { NgClass, NgStyle, PercentPipe } from "@angular/common";

@Component({
  selector: "onset-cloze-test-result",
  templateUrl: "./test-result.component.html",
  styleUrls: ["./test-result.component.scss"],
  standalone: true,
  imports: [ExerciseIndicatorComponent, NgStyle, NgClass, TranslatePipe, PercentPipe],
})
export class TestResultComponent implements OnInit, OnDestroy {
  readonly #route = inject(ActivatedRoute);
  readonly #ngxTranslate = inject(TranslateService);

  readonly results = input<TestResultDto>({} as TestResultDto);
  readonly showResult = input(false);
  readonly clozeTestStyleModel = input<ClozeTestStyleModel>({} as ClozeTestStyleModel);
  readonly cTestLogo = input("");
  readonly cTestButtonColor = input<string>("");
  readonly mobileMode = input(false);
  readonly totalExercise = input(0);
  readonly currentExerciseNumber = input(0);
  readonly showEndTestButton = input(false);
  readonly showGer = input(true);
  readonly showCustomButton = input(false);
  readonly customButtonIcon = input("");
  readonly customButtonIconHeight = input("");
  readonly customButtonText = input("");
  readonly customResultLevelText = input("");

  readonly clozeTest = output<boolean>();
  readonly gerInfo = output<boolean>();
  readonly customButton = output<boolean>();

  readonly #subscription = new Subscription();

  ngOnDestroy(): void {
    this.#subscription.unsubscribe();
  }

  ngOnInit() {
    const langSub = this.#route.queryParams.subscribe((params) => {
      if (params["lang"]) {
        const lang = params["lang"] as string;
        this.#ngxTranslate.use(lang.toLowerCase());
      }
    });
    this.#subscription.add(langSub);
  }

  public onClozeTest() {
    this.clozeTest.emit(true);
  }

  public onGerInfoClick() {
    this.gerInfo.emit(true);
  }

  public onCustomButton() {
    this.customButton.emit(true);
  }
}
